import { DocumentHolderModel } from "../../desktop/models/document-holder";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

export class DocumentHolderCollection extends Backbone.Collection<DocumentHolderModel> {
    constructor(options?) {
        super(options);
        this.model = DocumentHolderModel;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/collections/document-holders.ts